import { useStaticQuery, graphql } from "gatsby"

export const useFooterMenuQuery = () => {
  const { footerMainMenu, footerTopBarMenu } = useStaticQuery(
    graphql`
    query FooterMenuQuery {
        footerMainMenu: allWpMenuItem(
          filter: {parentDatabaseId: {eq: 0}, locations: {eq: PRIMARY_MENU}}
        ) {
          nodes {
            label
            path
          }
        }
        footerTopBarMenu: allWpMenuItem(
          filter: {parentDatabaseId: {eq: 0}, locations: {eq: TOP_BAR_MENU}}
        ) {
          nodes {
            label
            path
          }
        }
      }
    `
  )
  return {footerMainMenu, footerTopBarMenu}
}
